export let TRUST_DATA_FORM_STATES = /*#__PURE__*/function (TRUST_DATA_FORM_STATES) {
  TRUST_DATA_FORM_STATES["DRAFT"] = "draft";
  TRUST_DATA_FORM_STATES["LIVE"] = "live";
  return TRUST_DATA_FORM_STATES;
}({});
export let PARTNER_FORM_STATUS_TYPES = /*#__PURE__*/function (PARTNER_FORM_STATUS_TYPES) {
  PARTNER_FORM_STATUS_TYPES["SAVED"] = "SAVED";
  PARTNER_FORM_STATUS_TYPES["SUBMITTED"] = "SUBMITTED";
  PARTNER_FORM_STATUS_TYPES["REJECTED"] = "REJECTED";
  PARTNER_FORM_STATUS_TYPES["APPROVED"] = "APPROVED";
  return PARTNER_FORM_STATUS_TYPES;
}({});
export let AcceptableResponse = /*#__PURE__*/function (AcceptableResponse) {
  AcceptableResponse["NOT_APPLICABLE"] = "NOT_APPLICABLE";
  AcceptableResponse["TRUE"] = "TRUE";
  AcceptableResponse["FALSE"] = "FALSE";
  return AcceptableResponse;
}({});
// Data residency supported type
export const STORED_EXTERNAL_TO_ATLASSIAN = 'STORED_EXTERNAL_TO_ATLASSIAN';
export const STORED_IN_ATLASSIAN_AND_DR_SUPPORTED = 'STORED_IN_ATLASSIAN_AND_DR_SUPPORTED';
export const SUPPORTS_DATA_RESIDENCY = 'SUPPORTS_DATA_RESIDENCY';
export const APP_DOES_NOT_SUPPORT_DR = 'APP_DOES_NOT_SUPPORT_DR';
export const STORED_IN_ATLASSIAN_AND_DR_NOT_SUPPORTED = 'STORED_IN_ATLASSIAN_AND_DR_NOT_SUPPORTED';
export const NOT_APPLICABLE = 'NOT_APPLICABLE';